import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation,OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { JSONDOC2, JSONDOC1, JSONDOC3 } from './message-attachment-rich-text-document-text';
import { MessageAttachmentTemplateDialogComponent } from './message-attachment-template-dialog/message-attachment-template-dialog.component';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { toHTML,toDoc } from 'ngx-editor';
@Component({
  selector: 'dl-message-attachment',
  templateUrl: './message-attachment.component.html',
  styleUrls: ['./message-attachment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageAttachmentComponent implements OnInit,OnDestroy,OnChanges {
  public constructor(private readonly oneSnackBar: OneSnackBarService, private readonly dialog: MatDialog, private changeDetectorRef: ChangeDetectorRef, private _QnSbnDataService:QnSbnDataService, private qnsbnservice :QnSbnService) {}
  ngOnChanges(changes: SimpleChanges): void {
    // console.log('onchange--->',changes)
  }

  ngDoCheck() {
    // console.log('in do check-->',this._QnSbnDataService.storageForQnsbn);
    // this.addProduct(this.subjectname.value,this.textDoc);
  }
 
  public subjectname = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]);
  public updateFeedbackOptions: Subject<any> = new Subject<any>();
  public addTempleteCheck = false;
  public disabledApplyCheckbox = true;
  public disbledApplyButton = true;
  public isAfoBtnDisabled = false;
  public isAfoBtnExpanded = false;
  public applybuttonClickSnackmessage = '';
  public templateColumn = ['dragHandle', 'selectText', 'messageTemplate', 'iconSets'];
  public templateData = [];
  @Input() public textDoc;
  public keyUpForRTE = false;
  public keyUpForSubjectName = false;
  public notificationData: any;
  public templateSubject: string = '';
  public templateEmailText: string = '';
  public templateId: string = '';
  public ngOnInit(): void {
    this.subjectname.valueChanges.subscribe(x => {
      this.applybuttonClickSnackmessage = 'AddMessageFromTemplate';
      this.getApplybuttonStatus();
    });
    this._QnSbnDataService.mappingData$.subscribe(observer=>{
      this.notificationData = observer['localNotificationId'];
      if(!this._QnSbnDataService.isEmpty(observer['messageAttachment'])){
        this.templateSubject = observer['messageAttachment']['subjectName'];
        this.templateEmailText = observer['messageAttachment']['messageAttachmentRTEText'];
        this.templateId = observer['messageAttachment']['templateId'];
        this.subjectname.setValue(this.templateSubject);
        this.textDoc = this.templateEmailText;
      }
    })
  }

  public onKeyupSubjectName(evt) {
    evt.preventDefault();
    this.keyUpForSubjectName = true;
  }

  public onBlurSubjectName(evt) {
    this.subjectname.setValue(this.subjectname.value.trim());
    this.addProduct(this.subjectname.value,this.textDoc);
  }

  public createTemplateUsingApply(): void {
    const newTemplateData = {
      "templateSubject": this.subjectname.value,
      "templateBody": this.textDoc,
      "notificationType": this.notificationData.Type,
      "messageType": "Email",
      "templateLanguage": this.notificationData.LocalNotificationLanguage
    };
    
    this.qnsbnservice.createUpdateMessageTemplate(newTemplateData).subscribe(
      (responseData:any) => {
        this.addProduct(responseData.templateSubject,responseData.templateBody);
        this.oneSnackBar.open('Message successfully added to templates', OneSnackBarType.SUCCESS, '', { duration: 5000 });
        this.addTempleteCheck = false;
        this.disabledApplyCheckbox = true;
        this.disbledApplyButton = true;
        this.changeDetectorRef.detectChanges();
      },
      (error: HttpErrorResponse) => {
        // console.log('error:', error);
        this.qnsbnservice.httpErrorHandler(error, 'Could not save Message template.');
      }
    );
  }

  public onApplybuttonAction(): void {
    this.qnsbnservice.getMessageTemplate(this.notificationData.Type, this.notificationData.LocalNotificationLanguage).subscribe(
      (data:any) => {
        if(data.errorMessage) {
          this.createTemplateUsingApply();
        } else {
          const templateExist = data.MessageTemplates.some(template => 
            template.templateDetails.templateBody === this.textDoc && 
            template.templateDetails.templateSubject === this.subjectname.value);
          if(templateExist) {
            this.oneSnackBar.open('Template already exist with same data. Please verify the template.', OneSnackBarType.SUCCESS, '', { duration: 5000 });
            this.addTempleteCheck = false;
            this.disabledApplyCheckbox = true;
            this.disbledApplyButton = true;
            return;
          } else {
            this.createTemplateUsingApply();
          }
        }
      },
      (error: HttpErrorResponse) => {
        this.createTemplateUsingApply();
      }
    ); 
  }
  public chkApplyChange(values:any):void {
    this.disbledApplyButton = !values.checked;
  }

  public addProduct(subjectname,docRTEtext) {    
     this._QnSbnDataService.getMappedQnsbnData({
      "subjectName": subjectname,
      "messageAttachmentRTEText": docRTEtext,
      "templateId": this.templateId || ""
    },"MessageAttachment");
 }
  public openMsgAttachTempleteDialog(): void {
    // TODO: fetch data from server using API ?notificationtype=SBN&messagetype=Email&language=en
    this.qnsbnservice.getMessageTemplate(this.notificationData.Type, this.notificationData.LocalNotificationLanguage).subscribe(
      (data:any) => {
        if(data.errorMessage) {
          this.oneSnackBar.open(data.errorMessage.errorMessage, OneSnackBarType.ERROR, '', { duration: 5000 });
        } else {
          this.displayMessageTemplateDialog(data.MessageTemplates);
        }
      },
      (error: HttpErrorResponse) => {
        // console.log('error:', error);
        this.qnsbnservice.httpErrorHandler(error, 'Could not fetch message templates.');
      }
    );    
  }
  public displayMessageTemplateDialog(tempData) {
    this.isAfoBtnDisabled = false;
    this.isAfoBtnExpanded = false;
    const tableColumnData = ['dragHandle', 'selectText', 'messageTemplate', 'iconSets'];
    const templateDataList = tempData;

    const dialogRef = this.dialog.open(MessageAttachmentTemplateDialogComponent, {
      data: { tableData: templateDataList, columnData: tableColumnData },
      disableClose: true,
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result.data) { return; }
      this.isAfoBtnDisabled = false;
      this.isAfoBtnExpanded = false;
      this.textDoc = [];
      // const isNewMessageTemplate = this.templateData.length > 0 ? false : true;
      this.templateColumn = result.data.newColumnData;
      this.templateData = result.data.newTableData;
      // const newFeedbackDataSource = {
      //   templateData: this.templateData,
      //   placement: 'after'
      // };
      this.templateId = this.templateData[0].templateId;
      this.templateSubject = this.templateData[0].templateDetails.templateSubject;
      this.templateEmailText = this.templateData[0].templateDetails.templateBody;
      this.subjectname.setValue(this.templateData[0].templateDetails.templateSubject);
      this.textDoc = this.templateData[0].templateDetails.templateBody;
      this.applybuttonClickSnackmessage = 'AddMessageFromTemplate';
      // if (isNewMessageTemplate) {
      //   this.changeDetectorRef.detectChanges();
      // } else {
      //   this.updateFeedbackOptions.next(newFeedbackDataSource);
      // }
    });
  }

  public setRTEText(evt): void {
    const newText = toHTML(evt);
    if (this.textDoc === newText) {
      return;
    } else {
      this.textDoc = newText;
      // console.log('in message RTE ; - ',this.textDoc);
      this.applybuttonClickSnackmessage = 'AddMessageFromTemplate';
      this.getApplybuttonStatus();
      this.addProduct(this.subjectname.value,this.textDoc);
    }
  }

  public getApplybuttonStatus(): void {
    if (this.subjectname.status === 'VALID' && this.textDoc && this.textDoc !== '<p></p>') {
      this.disabledApplyCheckbox = false;
    } else {
      this.disbledApplyButton = true;
      this.disabledApplyCheckbox = true;
    }
  }
  ngOnDestroy(): void {
    this.addProduct(this.subjectname.value,this.textDoc);
  }
}
